import { ROUTE_PATH, Question_Type } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaDynamicFormModel, SmMetaTextAreaModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class FeedbackMetaModel extends FormMetaModel {
    constructor() {
      super('Add FeedBack', ROUTE_PATH.feedbackGrid, ROUTE_PATH.addFeedback, 1);
    }
  
     override initProperties(): any {
      const formInfo = super.initProperties();
      const title = new SmMetaInputModel(
        'title',
        'title',
        'input',
        true,
        'form-control col-12 col-md-6',
        1,
        1,
        'Title',
        'text',
        '',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      const categories = new SmMetaDynamicFormModel(
        'categories',
        'categories',
        'dynamicform',
        false,
        false,
        'form-group col-12 col-md-12',
        8,
        13,
        'Categories',
        'addlast',
        {
          category: new SmMetaInputModel(
            'category',
            'category',
            'input',
            false,
            ' form-group col-12 col-md-6 ',
            1,
            1,
            'Categories',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
          ),
        },
        5,
        true,
        true,
        true,
        true,
        [],
        32,
        true
      );
  
      const questions = new SmMetaDynamicFormModel(
        'questions',
        'questions',
        'dynamicform',
        false,
        false,
        'form-group col-12 col-md-12 m-0 p-0',
        8,
        13,
        'Add Questions',
        'addlast',
        {
          question_text: new SmMetaTextAreaModel(
            'question_text',
            'question_text',
            'SimpleTextarea',
            false,
            ' col-12 ',
            1,
            3,
            'Question',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            250,
            5
          ),
  
          // selected_category: new SmMetaSelectModel(
          //   'selected_category',
          //   'selected_category',
          //   'select',
          //   true,
          //   'col-12 col-md-6',
          //   1,
          //   4,
          //   'Selected Category',
          //   'number',
          //   '',
          //   false,
          //   true,
          //   true,
          //   false,
          //   0,
          //   0,
          //   false,
          //   TEMPLATE_OPTIONS,
          //   'name',
          //   'id',
          //   false,
          //   false,
          //   false,
          //   false,
          //   false,
          //   false
          // ),
  
          // selected_category: new SmMetaInputModel(
          //   'selected_category',
          //   'selected_category',
          //   'input',
          //   false,
          //   'form-group col-12 col-md-6',
          //   1,
          //   1,
          //   'Selected Category',
          //   'text',
          //   '',
          //   false,
          //   true,
          //   true,
          //   false,
          //   100,
          //   1
          // ),


          selected_category_text: new SmMetaSelectModel(
            'selected_category_text',
            'selected_category_text',
            'select',
            false,
            'col-12 col-md-6 mb-1',
            1,
            5,
            'Selected Category',
            'text',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'category',
            'category',
            false,
            false,
            false,
            false,
            false,
            false
          ),
  
  
          question_type: new SmMetaSelectModel(
            'question_type',
            'question_type',
            'select',
            false,
            'col-12 col-md-6 mb-1',
            1,
            5,
            'Question Type',
            'number',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            Question_Type,
            'name',
            'question_type',
            false,
            false,
            false,
            false,
            false,
            false
          ),
          options: new SmMetaDynamicFormModel(
            'options',
            'options',
            'dynamicform',
            false,
            false,
            'form-group col-12 col-md-12 m-0 p-0',
            8,
            13,
            'Add Options',
            'addlast',
            {
              option_text: new SmMetaInputModel(
                'option_text',
                'option_text',
                'input',
                false,
                'form-group col-12 col-md-6',
                1,
                1,
                'Option',
                'text',
                '',
                false,
                true,
                true,
                false,
                200,
                1
              ),
            },
            5,
            true,
            true,
            true,
            true,
            [],
            32,
            true,
            { evalKey: 'questionType', evalParam: ['1', '4', '6'] }
          ),
        },
        5,
        true,
        true,
        true,
        true,
        [],
        32,
        true
      );
  
      const buttons = {
        submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
        isFormControl: false,
      };
  
      return {
        formInfo,
        title,
        categories,
        // question,
        // selected_category,
        // questionType,
        questions,
  
        buttons,
      };
    }
  }


  export class feedbackForm {
    id?:'';
    feedbackFormId?:'';
    title: string = '';
    // categories: any[] = [];
    // questions: any[] = [];
    // selected_category: any = '';
    // questionType: any = '';
  }
  
  